import { IButton } from 'interfaces/components/button';

const Button = ({
  label,
  name,
  onClick,
  className,
  disabled,
  id,
  prefix
}: IButton) => {
  return (
    <button
      id={id}
      name={name}
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      {prefix}
      <span>{label}</span>
    </button>
  );
};

export default Button;
